import { type ComponentPropsWithoutRef, forwardRef } from 'react';

import LinkPreviewWrapper from 'molecules/SmartLink/LinkPreviewWrapper';

import parseUrl from 'utils/parse/parseUrl';

export type LinkProps = ComponentPropsWithoutRef<'a'> & {
  enablePreview?: boolean;
};

const Link = forwardRef<HTMLElement, LinkProps>(({ children, href, enablePreview, className, ...rest }, ref) => {
  const { as: Component, ...componentProps } = parseUrl(href || '');

  const isInternalOrPrismaticLink = typeof href === 'string' && (href.startsWith('/') || href.includes('prismatic.io'));
  const shouldPreview = enablePreview ?? isInternalOrPrismaticLink;

  const content = (
    <Component {...componentProps} {...rest} ref={ref} className={className}>
      {children}
    </Component>
  );

  return shouldPreview ? (
    <LinkPreviewWrapper href={href || ''} className={className}>
      {content}
    </LinkPreviewWrapper>
  ) : (
    content
  );
});

Link.displayName = 'Link';

export default Link;
